import {useCookies, useMediaQuery, useValidatePath} from "../../hooks";
import {useState, useEffect} from "preact/compat";
import Cookies from "js-cookie";
import { useUserContext } from "../../contexts";

export const useNewsletterModal = () => {
    // State to control whether the modal is open or not
    const [isOpen, setIsOpen] = useState(false);
    // Cookie to check if modal has already been displayed in previous access
    const [shouldDisplayModal, setShouldDisplayModal] = useCookies('newsletter_modal', true);

    // Retrieves the flag to check if user is at a special path route.
    // The modal can't be displayed if so.
    const {isSpecialPath} = useValidatePath();

    const isMobile = useMediaQuery("(max-width: 767px)");

    const [{}, {}, {}, {
        desktopNewsletterModal,
        mobileNewsletterModal,
    }] = useUserContext();

    // Effect to check whether the modal should be displayed or not
    useEffect(() => {
        const hasRegion = Cookies.get("location_modal");

        const adminConfig = isMobile ? mobileNewsletterModal : desktopNewsletterModal;

        if (
            hasRegion &&
            shouldDisplayModal &&
            !isSpecialPath &&
            adminConfig
        ) {
            // Displays the modal after a 2-second delay
            const timer = setTimeout(() => {
                setIsOpen(true);
                // TODO: the expire property isn't working as intended.
                //  The value being set is the default one.
                setShouldDisplayModal(false, 7);

                clearTimeout(timer);
            }, 2000);
        }
    }, [shouldDisplayModal, isSpecialPath, desktopNewsletterModal, mobileNewsletterModal]);

    return {
        isOpen,
        setIsOpen
    }
}
